<template>
  <v-layout
    v-if="loading"
    column
    align-center
    justify-center
    style="margin-top: 20vh"
  >
    <v-progress-circular
      :size="70"
      :width="7"
      color="primary"
      indeterminate
    ></v-progress-circular>
    <br />
    <div class="mt-2">Menyiapakan Data</div>
  </v-layout>
  <v-container fluid v-else>
    <div class="headline-container">
      <v-row>
        <v-col cols="12" md="6">
          <span class="headline">Surat Masuk</span>
        </v-col>
        <v-spacer></v-spacer>
        <v-col cols="6" md="2">
          <v-btn
            rounded
            color="default"
            class="mr-4"
            @click="$refs.laporan.show()"
          >
            <v-icon left color="primary" class="hidden-sm-and-down">
              mdi-printer
            </v-icon>
            CETAK LAPORAN
          </v-btn>
        </v-col>
        <v-col cols="6" md="2" v-if="hasPrivateAccess">
          <v-menu :close-on-content-click="true">
            <template v-slot:activator="{ on, attrs }">
              <v-btn rounded color="primary" v-bind="attrs" v-on="on">
                <v-icon left class="hidden-sm-and-down">
                  mdi-pencil
                </v-icon>
                INPUT SURAT
                <v-icon style="margin-left: 10px; font-size: 18px">
                  mdi-chevron-down
                </v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                v-for="(item, index) in jenisSurat"
                :key="index"
                @click="onAddButtonPressed(item)"
              >
                <v-list-item-title>{{
                  item.code.toUpperCase()
                }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-col>
      </v-row>
    </div>
    <v-card>
      <v-card-text class="pa-0">
        <v-container grid-list-md>
          <surat-masuk-list
            ref="suratMasukList"
            @handle-snackbar="emitSnackBar"
            @edit-surat="editData"
            id="suratMasukList"
          />
        </v-container>
      </v-card-text>
    </v-card>
    <surat-masuk-form
      ref="formSurat"
      @submited="onFormSubmited"
      @handle-snackbar="emitSnackBar"
    />
    <laporan ref="laporan" />
  </v-container>
</template>

<script>
import SuratMasukList from '@/components/SuratMasuk/List'
import Laporan from '@/components/SuratMasuk/Laporan'
import SuratMasukForm from '@/components/SuratMasuk/Form'
import { mapGetters } from 'vuex'

export default {
  components: {
    SuratMasukList,
    SuratMasukForm,
    Laporan
  },
  data() {
    return {
      loading: false,
      textFieldMonthType: 'number',
      selectedDate: '',
      rekaps: []
    }
  },
  computed: {
    ...mapGetters(['hasPrivateAccess', 'jenisSurat', 'isSekpri'])
  },
  async mounted() {
    this.$store.dispatch('loadJabatan')
  },
  methods: {
    emitSnackBar(text, color) {
      this.$emit('handle-snackbar', text, color)
    },
    onAddButtonPressed(jenis) {
      this.$refs.formSurat.show(jenis)
    },
    editData(data) {
      const jenis = this.jenisSurat.find(
        jenis => jenis.id === data.jenis_surat_id
      )
      this.$refs.formSurat.show(jenis, data)
    },
    onFormSubmited(isEdit = false) {
      this.$refs.suratMasukList.loadData(isEdit ? undefined : 1)
    }
  }
}
</script>

<style lang="sass" scoped></style>
